import { render } from "./AgeSliderComponentTwo.vue?vue&type=template&id=24bdc1b0&scoped=true"
import script from "./AgeSliderComponentTwo.vue?vue&type=script&lang=js"
export * from "./AgeSliderComponentTwo.vue?vue&type=script&lang=js"

import "./AgeSliderComponentTwo.vue?vue&type=style&index=0&id=24bdc1b0&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bdc1b0"]])

export default __exports__